export const googleMapStyle = [
  {
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#000000',
      },
    ],
  },
  {
    'featureType': 'landscape.man_made',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#000000',
      },
    ],
  },
  {
    'featureType': 'poi.government',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#000000',
      },
    ],
  },
  {
    'featureType': 'poi.medical',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#000000',
      },
    ],
  },
  {
    'featureType': 'poi.park',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#000000',
      },
    ],
  },
  {
    'featureType': 'poi.place_of_worship',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#000000',
      },
    ],
  },
  {
    'featureType': 'transit.station.airport',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#000000',
      },
    ],
  },
];